import { useState, useMemo, useContext } from 'react';

import { useAppDispatch } from 'redux/store';
import { getMentorRequests } from 'redux/actions/mentorship-program-connections';
import { getMentoringRequestList } from 'redux/selectors/mentorship-program-connections';

import { usePaginatedApi } from 'shared/hooks/use-paginated-api';
import MentoringProgramContext from 'athena/components/mentoring-program/context';

const useMentoringRequests = () => {
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(1);

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const {
    id: mentorshipProgramId,
    mentorshipProgramEnrollment: enrollmentId,
  } = mentoringProgram || {};

  const params = useMemo(
    () => ({
      mentorshipProgramId,
      enrollmentId,
      page,
      pageSize: 50,
    }),
    [mentorshipProgramId, enrollmentId, page],
  );

  const {
    result: mentoringRequests,
    reset,
  } = usePaginatedApi(
    (p) => dispatch(
      getMentorRequests(p),
    ).then((action) => action.payload.connectionRequests),
    params,
    getMentoringRequestList,
  );

  return {
    mentoringRequests,
    reset,
    setPage,
  };
};

export default useMentoringRequests;
